import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import * as $ from 'jquery'
import plupload from 'plupload'
import axios from 'axios'
import * as THREE from 'three'
require("three-orbitcontrols")
require("../../libs/STLLoader.js")
require("../../libs/OBJLoader.js")
require("../../libs/TDSLoader.js")
require("../../libs/STLExporter.js")
import {
signedVolumeOfTriangle
} from '../../libs/volumeOfGeometry.js';
import {
DRACOLoader
} from '../../../static/DRACOLoader'
import noticebar from '../../components/noticebar';




import login from '../login/login'
import printHead from '../../components/printHead'
import common from '../../common/common'
import {
mapGetters,
mapMutations,
mapActions
} from 'vuex'







export default {
name: 'print',
components: {
XHeader,
Actionsheet,
Group,
Cell,
Swiper,
SwiperItem,
XButton,
Flexbox,
FlexboxItem,
XInput,
XNumber,
Popup,
Checker,
CheckerItem,
Checklist,
Radio,
'login': login,
'printHead': printHead,
Icon,
Confirm,
noticebar,
},
data() {
return {
issm: false,
isprintingMethod: false,
printingMethod: '请选择',
PrintOptions: [{
key: '整件打印',
value: '整件打印',

}, {
key: '分件打印',
value: '分件打印',

}, ],


gxItem: {},

isxtg: false,


gyopt: '1',


isfx: false,

gt: '无',
gtOptions: [{
key: '无',
value: '无',
}, {
key: '镶铜螺母/攻牙',
value: '镶铜螺母/攻牙',
}],


gxObjs: {

gyop: [{
name: 'M2',
cd: '3',
zj: '1.6',
sum: 0,
},
{
name: 'M2.5',
cd: '3',
zj: '2.1',
sum: 0,
}, {
name: 'M3',
cd: '3',
zj: '2.5',
sum: 0,
}, {
name: 'M4',
cd: '4',
zj: '3.3',
sum: 0,
}, {
name: 'M5',
cd: '5',
zj: '4.2',
sum: 0,
},


{
name: 'M6',
cd: '6',
zj: '5',
sum: 0,
}, {
name: 'M8',
cd: '8',
zj: '6.8',
sum: 0,
}, {
name: 'M10',
cd: '10',
zj: '8.5',
sum: 0,
}
],

xtlmop: [{
name: 'M2',
cd: '3',
zj: '3',
sum: 0,
}, {
name: 'M2.5',
cd: '3',
zj: '3.5',
sum: 0,
},
{
name: 'M3*3',
cd: '3',
zj: '3.8',
sum: 0,
},
{
name: 'M3*5',
cd: '5',
zj: '3.8',
sum: 0,
},
{
name: 'M4*4',
cd: '4',
zj: '5.3',
sum: 0,
},
{
name: 'M4*8',
cd: '8',
zj: '5.3',
sum: 0,
},
{
name: 'M5',
cd: '5',
zj: '6.8',
sum: 0,
},
{
name: 'M6',
cd: '6',
zj: '7.8',
sum: 0,
},
{
name: 'M8',
cd: '8',
zj: '9.8',
sum: 0,
},
{
name: 'M10',
cd: '10',
zj: '11.8',
sum: 0,
},
],


},


isgt: false,

isjtgt: '1', //'1'螺母   ‘2’ 攻牙










options: {
text: '', // 通知内容
icon: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=735421754,4062673022&fm=26&gp=0.jpg', // 左侧图标(不需要icon不传)
iconSize: '16px', // icon大小（正方形默认16px）
size: '12px', // 通知内容文字大小（默认16px）
color: '#666', // 通知内容文字颜色(默认#f60)
backround: '#ffff', //背景颜色(默认#fff7cc)
delay: '1000', // 动画延迟时间(默认一秒后开始滚动，单位毫秒)
speed: '50' 
},
menuslist: {
公司简介: '公司简介',
服务介绍: '服务介绍',
联系我们: '联系我们',
QQ客服: 'QQ客服'
},
company: false, //公司简介

time: 5000, //折扣消息
promotionInfo: [], //促销
isPromotion: true, //是否显示促销
isMonthly: true, //是否月结用户


roundValue: 1,


materialsPopup: false,

colorShow: false,

surfacePopup: false,

timePopup: false,
timeIndex: '',

unitPopup: false,

preview: false, //3D预览

iszj: false,

fileVews: '',

materialsData: '', //材料数据
materialsList: [], // 材料列表
materialsSelected: '', //材料默认选中

colorData: '', //颜色数据
colorList: [], // 颜色列表
colorSelected: '', //颜色默认选中


surfaceData: '',
surfaceList: [],
surfaceIdList: [],
surfaceSelected: '', //表面处理默认选中
surfaceSelectedTip: '', //表面处理默认选中提示
surfaceOpenTip: '（喷油需增加3天交期）', //表面处理打开提示
surfaceChangeValue: '', //表面处理修改后
colorNumber: '', //潘通色号
colorNumberShow: false, //表面处理潘通色号


deliveryData: '',
deliveryList: [],
deliverySelected: '', //材料默认选中


unitList: ['mm', 'cm', 'm', 'inch', ],
unitSelected: '', //材料默认选中

materials: '', //材料
materialsId: '', //默认材料id
unit: 'mm', //  单位unit
color: '', //颜色
colorId: '', //颜色
delivery: '', //交期
surface: '', //表面处理

isUpFile: false, //是否第一次上传文件
fileIndex: 0, //文件数据索引
updatedParameter: '', //更新参数标记

fileDataList: [], // 文件参数列表

quoteParameter: [], //报价参数

returnData: [], //返回的数据

totalPrice: 0, //总价
noDrawingPopup: false, //无图纸报价
noDrawingType: 'knowVolume', //无图纸报价类型
noDrawingImg: require('../../assets/images/printLogo.png'),
noDrawingName: '',
noDrawingWeight: 0,
noDrawingVolume: '',
noDrawingLength: 0,
noDrawingWidth: 0,
noDrawingHeight: 0,
noDrawingMaterialsSelect: false, //无图纸选择材料标记
noDrawingMaterials: '', //无图纸默认材料
noDrawingMaterialsId: '',

hint: false, //提示
hintText: '请输入参数',

noticePopup: false, //打印须知

loginShow: false, //登录

cartOrBuy: '', //登录回调标记

controls: '', //3D预览控制器

host: '',
policyBase64: '',
accessid: '',
signature: '',
expire: '',

key: '',
ossKey: '', //oss密钥

uploadPercent: 0,


render: false, //3D渲染标识
minPriceShow: false, //最低价提示
uploadTime: '', //OSS上传时间
gxItemsm: [],

surfaceDayList: [], //后处理交期

}

},
watch: {

hint(val) {
if (val) {
setTimeout(() => {
this.hint = false
}, 3000)
}
},
},

methods: {

...mapGetters([
'getterPrintNoticeDetail'
]),
...mapMutations([
'mutationsPrintNoticeDetail'
]),
...mapActions([
'actionsPrintNoticeDetail'
]),
detailPage(title, type) {
let obj = {
printNoticeDetailType: type,
printNoticeDetailTitle: title,
}
this.$store.dispatch('actionsPrintNoticeDetail', obj)
this.$router.push({
path: 'printNotice',



})



},

sm() {
console.log('asdsadasd');

this.issm = true

this.gxItemsm = this.isjtgt == '1' ? JSON.parse(JSON.stringify(this.gxObjs.xtlmop)) : JSON.parse(JSON.stringify(this.gxObjs.gyop))


},
opa(val) {
this.isjtgt = val

},

qxsum() {


let nut = ''
for (let i = 0; i < this.fileDataList[this.fileIndex].gxObjs.xtlmop.length; i++) {
if (this.fileDataList[this.fileIndex].gxObjs.xtlmop[i].sum > 0) {

nut = nut + this.fileDataList[this.fileIndex].gxObjs.xtlmop[i].name + ',' + this.fileDataList[this.fileIndex].gxObjs.xtlmop[i].sum + '个' + ';'

}
}
this.fileDataList[this.fileIndex].nut = nut != '' ? nut.substring(0, nut.length - 1) : nut
this.quoteParameter[this.fileIndex].nut = this.fileDataList[this.fileIndex].nut

this.editParameter()

},
setgyChon() {
let attackTeeth = ''
for (let i = 0; i < this.fileDataList[this.fileIndex].gxObjs.gyop.length; i++) {
if (this.fileDataList[this.fileIndex].gxObjs.gyop[i].sum > 0) {
attackTeeth = attackTeeth + this.fileDataList[this.fileIndex].gxObjs.gyop[i].name + ',' + this.fileDataList[this.fileIndex].gxObjs.gyop[i].sum + '个' + ';'

}

}

this.fileDataList[this.fileIndex].attackTeeth = attackTeeth != '' ? attackTeeth.substring(0, attackTeeth.length - 1) : attackTeeth
this.quoteParameter[this.fileIndex].attackTeeth = this.fileDataList[this.fileIndex].attackTeeth



this.editParameter()
},


getPromotion() {
this.$request.post('/message/promotion', {}).then((response) => {

if (response.code == 0) {




let moticeText = ''
if (response.obj != null && response.obj.length != 0) {
if (response.obj.length > 0 && response.obj.length < 2) {
for (let i = 0; i < 3; i++) {

moticeText += response.obj[i].promotionContent + ' '

}
this.options.text = moticeText
} else {
this.promotionInfo = response.obj;
for (let i = 0; i < response.obj.length; i++) {
moticeText += response.obj[i].promotionContent + ' '
}
this.options.text = moticeText
}
} else {
this.promotionInfo.push({
'promotionContent': '公告：暂无活动公告'
})
}

} else {
this.$vux.toast.show({
type: 'warn',
text: response.msg
})
}
})
},


getMaterials() {
this.$request.post('/materials/listMaterials', {}).then((response) => {
if (response.code == 0) {



this.materialsId = response.obj[0].id
this.materials = response.obj[0].materialName


this.color = response.obj[0].listColor[0].colorName;
this.colorId = response.obj[0].listColor[0].id;


this.delivery = response.obj[0].listDelivery[response.obj[0].listDelivery.length - 1].days


this.noDrawingMaterials = response.obj[0].materialName
this.noDrawingMaterialsId = response.obj[0].id

this.fileDataList[0].materialName = response.obj[0].materialName;
this.fileDataList[0].materialId = response.obj[0].id;





this.materialsData = response.obj

for (let i = 0; i < response.obj.length; i++) {
var obj = {}
obj.key = response.obj[i].id
obj.value = response.obj[i].materialName
this.materialsList.push(obj);
}


this.getColor(response.obj[0].id);
this.getDelivery(response.obj[0].id);
this.getSurface(response.obj[0].id);

}
})
},


getColor(materialId) {
this.$request.post('/color/listColor', {
'materialId': materialId
}).then((response) => {
console.log(response)
if (response.code == 0) {
this.colorData = response.obj;
this.fileDataList[this.fileIndex].colorName = response.obj[0].colorName;
this.fileDataList[this.fileIndex].colorId = response.obj[0].id;

this.colorList = []
if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].colorName = response.obj[0].colorName
this.quoteParameter[this.fileIndex].colorId = response.obj[0].id;
}
for (let i = 0; i < response.obj.length; i++) {
this.colorList.push(response.obj[i].colorName);
}
this.updatedParameter++;
console.log(this.updatedParameter);
if (this.updatedParameter == 3) {
this.editParameter()
}
}
})
},

async getMaterialRelated(materialId) {

try {
const response = await axios.get(`${this.$baseURL}/materials/getMaterialRelated/${materialId}`);
console.log('材料后处理--------', response.data);

return response.data;
} catch (error) {
console.log('获取材料后处理失败--------', error);

throw error;
}
},


getSurfaceDay() {
this.$request.post('/quotation/surfaceDay', {}).then((response) => {
if (response.code == 0) {
this.surfaceDayList = response.obj;
}
})
},

getDay(val) {
return this.surfaceDayList[val];
},


getSurface(materialId) {
this.$request.post('/surface/listsurface', {
'materialId': materialId
}).then((response) => {
console.log('表面处理--------', response)
if (response.code == 0) {

this.surfaceData = response.obj;


this.fileDataList[this.fileIndex].surface = '无';
this.surfaceSelected = '无'

this.surfaceSelectedTip = '';
this.surfaceOpenTip = '（喷油需增加3天交期）';
if (this.surfaceSelected.indexOf("无") == -1) {
this.surfaceSelectedTip = `提示： 喷${this.surfaceSelected}需要额外增加${this.getDay(this.surfaceSelected)}天交期`;

if (this.surfaceSelected.indexOf("喷光油") != -1 || this.surfaceSelected.indexOf("喷哑油") != -1) {
this.surfaceSelectedTip = `提示： ${this.surfaceSelected}需要额外增加${this.getDay(this.surfaceSelected)}天交期`;
}

this.surfaceOpenTip = '（喷油需增加' + this.getDay(this.surfaceSelected) + '天交期）';
}

this.surfaceList = ['无']
this.surfaceIdList = ['default']
if (response.obj.length != 0) {

for (let i = 0; i < response.obj.length; i++) {
console.log(this.surfaceList)
this.surfaceList.push(response.obj[i].surfaceName);
this.surfaceIdList.push(response.obj[i].id);
}
}

this.updatedParameter++;
console.log(this.updatedParameter);
if (this.updatedParameter == 3) {
this.editParameter()
}

}
})
},


qkx() {

this.fileDataList[this.fileIndex].gxObjs = JSON.parse(JSON.stringify(this.gxObjs)),
this.fileDataList[this.fileIndex].attackTeeth = ''
this.fileDataList[this.fileIndex].nut = ''

},


getDelivery(materialId) {
this.$request.post('/delivery/listDelivery', {
'materialId': materialId
}).then((response) => {
console.log(response)
if (response.code == 0) {
var timeindex = response.obj.length - 1

if (materialId == "6c04a66b-a08b-11e8-8564-1c1b0daf" || materialId == "806ef16d474445429d7ed8f7b18dda5a" || materialId == "60f8435de6e54e96ba3595f576dd3ba3") {
for (var i = 0; i < response.obj.length; i++) {
if (response.obj[i].days == 3) {
timeindex = i
console.log('timeindex-', timeindex)

break;
} else {
timeindex = response.obj.length - 1
console.log('timeindex', timeindex)

}
}
} else {
timeindex = response.obj.length - 1
}

this.deliveryData = response.obj;
this.quoteParameter[this.fileIndex].deliveryDays = response.obj[timeindex].days;
this.fileDataList[this.fileIndex].deliveryDays = response.obj[timeindex].days + '天'


this.deliveryList = []



for (let i = 0; i < response.obj.length; i++) {
this.deliveryList.push(response.obj[i].days + '天');
}

this.updatedParameter++;
console.log(this.updatedParameter);
if (this.updatedParameter == 3) {
this.editParameter()
}
}
})
},


materialsOpen(i) {
console.log(i);

this.fileIndex = i;

this.materialsSelected = this.fileDataList[i].materialId;




this.$nextTick(function () {
this.materialsPopup = true;

})
},


printingMethodOpen(i) {

this.fileIndex = i;
this.$nextTick(function () {
this.isprintingMethod = true;

})
},


materialsChange(val, label) {

this.updatedParameter = 0;


if (this.noDrawingMaterialsSelect == true) {
this.noDrawingPopup = true;

this.noDrawingMaterials = label 
this.noDrawingMaterialsId = val

if (this.noDrawingWeight == '') {
this.hint = true;
this.hintText = '请输入重量'
return false;
}

this.getNoDrawingVolume();
return false
}



if (val != '') {
if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].materialId = val

}







this.getColor(val);

this.getDelivery(val);

this.getSurface(val);
}

this.materialsPopup = false;

this.fileDataList[this.fileIndex].materialName = label
this.fileDataList[this.fileIndex].materialId = val


if (this.fileDataList[this.fileIndex].materialId == "6c04a66b-a08b-11e8-8564-1c1b0daf" || this.fileDataList[this.fileIndex].materialId == "806ef16d474445429d7ed8f7b18dda5a" || this.fileDataList[this.fileIndex].materialId == "60f8435de6e54e96ba3595f576dd3ba3") {
this.fileDataList[this.fileIndex].isshow = true
} else {
this.fileDataList[this.fileIndex].isshow = false
}

},


colorOpen(i) {
this.fileIndex = i

this.colorSelected = this.fileDataList[i].colorName;
this.$nextTick(function () {
this.colorShow = true;
})


let updateColorList = '';

for (let i = 0; i < this.materialsData.length; i++) {
if (this.fileDataList[this.fileIndex].materialId == this.materialsData[i].id) {

updateColorList = this.materialsData[i].listColor
}
}

this.colorList = []
for (let i = 0; i < updateColorList.length; i++) {
this.colorList.push(updateColorList[i].colorName)
}
},


colorChange(val, label) {

this.colorShow = false

let colorId = '';
for (let i = 0; i < this.colorData.length; i++) {
if (this.colorData[i].colorName == label) {
colorId = this.colorData[i].id;
}
}

this.fileDataList[this.fileIndex].colorName = label

if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].colorId = colorId
this.quoteParameter[this.fileIndex].colorName = label
this.editParameter()
}


},


printingChange(val, label) {
this.fileDataList[this.fileIndex].printingMethod = val
this.isprintingMethod = false


console.log('this.fileDataList', this.fileDataList);

},


surfaceOpen(i) {
this.fileIndex = i

this.surfaceSelected = this.fileDataList[i].surface;
this.$nextTick(function () {
this.surfacePopup = true;
})

this.surfaceSelectedTip = '';
this.surfaceOpenTip = '（喷油需增加3天交期）';
if (this.surfaceSelected.indexOf("无") == -1) {
this.surfaceSelectedTip = `提示： 喷${this.surfaceSelected}需要额外增加${this.getDay(this.surfaceSelected)}天交期`;

if (this.surfaceSelected.indexOf("喷光油") != -1 || this.surfaceSelected.indexOf("喷哑油") != -1) {
this.surfaceSelectedTip = `提示： ${this.surfaceSelected}需要额外增加${this.getDay(this.surfaceSelected)}天交期`;
}

this.surfaceOpenTip = '（喷油需增加' + this.getDay(this.surfaceSelected) + '天交期）';
}









if (this.fileDataList[i].surface.indexOf('光油') == -1 && this.fileDataList[i].surface.indexOf('哑油') == -1) {
this.colorNumber = ''; 
this.colorNumberShow = false; 
}



let updatesurfaceList = '';

for (let i = 0; i < this.materialsData.length; i++) {
if (this.fileDataList[this.fileIndex].materialId == this.materialsData[i].id) {

updatesurfaceList = this.materialsData[i].listSurface
}
}

this.surfaceList = ['无']
this.surfaceIdList = ['default']
for (let i = 0; i < updatesurfaceList.length; i++) {
this.surfaceList.push(updatesurfaceList[i].surfaceName)
this.surfaceIdList.push(updatesurfaceList[i].id)
}
},

getName(key) {

let name = ''
for (let i = 0; i < this.gtOptions.length; i++) {
if (key = this.gtOptions[i].key) {
name = this.gtOptions[i].value
}

}
return name
},
gtChange(item) {


console.log('item', item.key);



this.fileDataList[this.fileIndex].gt = item.key

if (item.key == '镶铜螺母/攻牙') {
this.isgt = false
this.isxtg = true

} else {
this.qkx()
}



},
xgOpen(item, i) {
this.fileIndex = i



this.gt = this.fileDataList[this.fileIndex].gt


this.$forceUpdate()



this.$nextTick(function () {
this.isgt = true;
})
},



surfaceConfirm() {

if (this.colorNumber == '' && (this.surfaceChangeValue.indexOf('光油') != -1 || this.surfaceChangeValue.indexOf('哑油') != -1)) {
this.$vux.toast.show({
type: 'warn',
text: '请填写潘通色号'
})
return false;
}

this.fileDataList[this.fileIndex].surface = this.surfaceChangeValue

let surfaceId = '';
console.log("surfaceData:", this.surfaceData)

for (let i = 0; i < this.surfaceIdList.length; i++) {
if (this.surfaceList[i] == this.surfaceChangeValue) {
surfaceId = this.surfaceIdList[i]
}
}


if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].listSurface[0].colorValue = this.colorNumber;
this.quoteParameter[this.fileIndex].listSurface[0].surfaceName = this.surfaceChangeValue;
this.quoteParameter[this.fileIndex].listSurface[0].id = surfaceId;

}

if (this.fileDataList[this.fileIndex]) {
this.fileDataList[this.fileIndex].listSurface[0].colorValue = this.colorNumber;
this.fileDataList[this.fileIndex].listSurface[0].surfaceName = this.surfaceChangeValue;
this.fileDataList[this.fileIndex].listSurface[0].id = surfaceId;
}

this.editParameter()

this.surfacePopup = false;
},


surfaceChange(val, label) {

this.colorNumber = '';

if (label.indexOf('光油') != -1 || label.indexOf('哑油') != -1) {
this.colorNumberShow = true;
} else {
this.colorNumberShow = false;
}

this.surfaceChangeValue = label;

this.surfaceSelectedTip = '';
this.surfaceOpenTip = '（喷油需增加3天交期）';
if (this.surfaceChangeValue.indexOf("无") == -1) {
this.surfaceSelectedTip = `提示： 喷${this.surfaceChangeValue}需要额外增加${this.getDay(this.surfaceChangeValue)}天交期`;

if (this.surfaceChangeValue.indexOf("喷光油") != -1 || this.surfaceChangeValue.indexOf("喷哑油") != -1) {
this.surfaceSelectedTip = `提示： ${this.surfaceChangeValue}需要额外增加${this.getDay(this.surfaceChangeValue)}天交期`;
}

this.surfaceOpenTip = '（喷油需增加' + this.getDay(this.surfaceChangeValue) + '天交期）';
}

},


deliveryOpen(i) {
this.fileIndex = i;

this.deliverySelected = this.fileDataList[i].deliveryDays;

this.$nextTick(function () {
this.timePopup = true
})



let updatedeliveryList = '';

for (let i = 0; i < this.materialsData.length; i++) {
if (this.fileDataList[this.fileIndex].materialId == this.materialsData[i].id) {

updatedeliveryList = this.materialsData[i].listDelivery
}
}

this.deliveryList = []
for (let i = 0; i < updatedeliveryList.length; i++) {
this.deliveryList.push(updatedeliveryList[i].days + '天')
}
},


deliveryChange(val, label) {
this.timePopup = false
this.fileDataList[this.fileIndex].deliveryDays = label
if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].deliveryDays = label.split('天')[0]
this.editParameter()
}
},


unitOpen(i) {
this.fileIndex = i;
this.unitSelected = this.fileDataList[i].unit;
this.$nextTick(function () {
this.unitPopup = true;
})
},


unitChange(val, label) {
console.log(label)
this.unitPopup = false

this.fileDataList[this.fileIndex].unit = label

if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].unit = label
this.editParameter()
}

},


quantityChange(i, val) {
console.log(i)
console.log(val)
this.fileIndex = i



if (this.quoteParameter.length != 0) {
this.quoteParameter[i].quantity = val

this.editParameter()
}
},


miniPrice(i) {
this.fileIndex = i;
this.editParameter('最低价');
},


removeFile(i) {
if (this.fileDataList.length == 1 && this.fileDataList[0].quotationName == 'stl') {
return false;
}
this.fileDataList.splice(i, 1);
this.quoteParameter.splice(i, 1);
this.returnData.splice(i, 1);
$($('.previewBox canvas')[i]).remove();

this.calculateTotalPrice();
if (this.fileDataList.length == 0) {
this.isUpFile = false
this.defaultList();
this.getMaterials();
this.getSurfaceDay();
}
},


filePreview(i) {
this.render = true;
if (this.fileDataList.length == 0 || (this.fileDataList.length == 1 && this.fileDataList[0].quotationName == 'stl')) {
return false;
}
this.fileIndex = i;
this.preview = true
$('.previewBox canvas').hide();
$($('.previewBox canvas')[i]).show();





},


show() {
this.company = true
},


companySelecet(key) {
console.log(key)
},

onBlur() {
console.log('11')
},

getOssKey(url) {
this.$request.post(url, {})
.then((response) => {
console.log(response);
if (response.code == 0) {
var obj = response.obj
this.host = obj['host']
this.policyBase64 = obj['policy']
this.accessid = obj['accessid']
this.signature = obj['signature']
this.expire = obj['expire']

this.key = obj['dir']
}
})
},






upFile(url, browseButton, container, extensions) {

let that = this;

$('.moxie-shim-html5').remove();
var accessid = ''
var accesskey = ''
var host = ''
var policyBase64 = ''
var signature = ''
var callbackbody = ''
var filename = ''
var key = ''
var expire = 0
var g_object_name = ''
var g_object_name_type = ''
var timestamp = Date.parse(new Date()) / 1000;
var now = timestamp;

function check_object_radio() {
var tt = document.getElementsByName('myradio');
for (var i = 0; i < tt.length; i++) {
if (tt[i].checked) {
g_object_name_type = tt[i].value;
break;
}
}
}

function get_signature() {


now = timestamp = Date.parse(new Date()) / 1000;
if (expire < now + 3) {




host = that.ossKey['host'] 

policyBase64 = that.ossKey['policy'] 
accessid = that.ossKey['accessid'] 
signature = that.ossKey['signature'] 
expire = that.ossKey['expire'] 

key = that.ossKey['dir'] 

return true;
}
return false;
};

function random_string(len) {
len = len || 32;
var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
var maxPos = chars.length;
var pwd = '';
for (let i = 0; i < len; i++) {
pwd += chars.charAt(Math.floor(Math.random() * maxPos));
}
return pwd;
}

function get_suffix(filename) {
let pos = filename.lastIndexOf('.')
let suffix = ''
if (pos != -1) {
suffix = filename.substring(pos)
}
return suffix;
}

function calculate_object_name(filename) {
if (g_object_name_type == 'local_name') {
g_object_name += "${filename}"
} else if (g_object_name_type == 'random_name') {
let suffix = get_suffix(filename)
g_object_name = key + random_string(10) + suffix
}
return ''
}



function get_uploaded_object_name(filename) {
if (g_object_name_type == 'local_name') {
let tmp_name = g_object_name
tmp_name = tmp_name.replace("${filename}", filename);
return tmp_name
} else if (g_object_name_type == 'random_name') {
return g_object_name
}
}

function set_upload_param(up, filename, ret) {
if (ret == false) {
ret = get_signature()
}
g_object_name = key;
if (filename != '') {
let suffix = get_suffix(filename)
calculate_object_name(filename)
}
let new_multipart_params = {
'key': g_object_name,
'policy': policyBase64,
'OSSAccessKeyId': accessid,
'success_action_status': '200', //让服务端返回200,不然，默认会返回204

'signature': signature,
};

up.setOption({
'url': host,
'multipart_params': new_multipart_params
});

up.start();

}







let uploadStartTime = '';

var uploader = new plupload.Uploader({
runtimes: 'html5,flash,silverlight,html4',

browse_button: browseButton,
multi_selection: false,

container: document.getElementById(container),
flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
url: 'http://oss.aliyuncs.com',

filters: {

mime_types: [],
max_file_size: '100mb', //最大只能上传100mb的文件
prevent_duplicates: false 
},

max_retries: 3, //请求错误时的重试次数，为0时表示不重试

init: {
PostInit: () => {
document.getElementById('ossfile').innerHTML = '';




},

FilesAdded: (up, files) => {

uploadStartTime = Date.parse(new Date());

let ext = files[0].name.split('.')[1].toLowerCase();
if (extensions == 'stl' && (ext != 'stl' && ext != 'obj' && ext != '3ds' && ext != 'stp' && ext != 'step' && ext != 'igs' && ext != 'iges')) {
this.$vux.toast.show({
type: 'warn',
text: '请上传 stl，stp，step，igs，iges，obj，3ds 文件'
})
return false;
}
if (extensions == 'jpeg,png,jpg') {
if (files[0].name.split('.')[1] != 'jpeg' && files[0].name.split('.')[1] != 'jpg' && files[0].name.split('.')[1] != 'png') {
this.$vux.toast.show({
type: 'warn',
text: '请上传图片'
})
return false;
}
}
this.uploadPercent = 0
set_upload_param(uploader, '', false);
plupload.each(files, (file) => {
document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b>' +
'<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
'</div>';
});
},

BeforeUpload: function (up, file) {
check_object_radio();
set_upload_param(up, file.name, true);
},

UploadProgress: (up, file) => {
this.$vux.loading.show({
text: '上传解析中 ' + this.uploadPercent + '%'
})
this.uploadPercent = file.percent
console.log(file.percent)

var d = document.getElementById(file.id);
d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
var prog = d.getElementsByTagName('div')[0];

var progBar = prog.getElementsByTagName('div')[0]

progBar.style.width = 2 * file.percent + 'px';
progBar.setAttribute('aria-valuenow', file.percent);

},

FileUploaded: (up, file, info) => {
if (info.status == 200) {
var ossPath = host + '/' + get_uploaded_object_name(file.name);
console.log(ossPath)

this.uploadTime = Date.parse(new Date()) - uploadStartTime

console.log(this.uploadTime);

var index1 = file.name.lastIndexOf(".");
var index2 = file.name.length;
var suffix = file.name.substring(index1 + 1, index2).toLowerCase();
if (suffix == 'xxx') {



axios.post(this.$baseURL + '/quotation/changeNew', {
'filePath': ossPath,
ext: suffix
}, {
responseType: 'blob'
}).then((response) => {
console.log(response);
this.threeParse(response.data, file, ossPath)
})
} else {


axios.post(this.$baseURL + '/quotation/changeNew', {
'filePath': ossPath,
ext: '.drc'
}, ).then((response) => {

if (response.data.code == 0) {
this.drcPreview(ossPath, file, response.data.obj.CoordinateBean, this.uploadTime);
} else {
this.$vux.toast.show({
type: 'warn',
text: response.data.msg
})
}

})
}





if (browseButton == 'noDrawingImg') {
this.$vux.loading.hide()
this.noDrawingImg = ossPath;
}
}
},

Error: function (up, err) {
if (err.code == -600) {
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了"));
} else if (err.code == -601) {
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对"));
} else if (err.code == -602) {
document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
} else {
document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
}
}
}
});

uploader.init();
setTimeout(() => {
this.$request.post(url, {}).then((response) => {
console.log(response);
if (response.code == 0) {
that.ossKey = response.obj
} else {
return;
}
})
}, 0);

},


getQuote(type) {

let that = this;

this.$request.post('/quotation/create', this.quoteParameter).then((response) => {
var sumdata = 0;

for (var i = 0; i < response.obj.quotations.length; i++) {
this.quoteParameter[i].image = response.obj.quotations[i].image


if (response.obj.quotations[i].materialId == "6c04a66b-a08b-11e8-8564-1c1b0daf" || response.obj.quotations[i].materialId == "806ef16d474445429d7ed8f7b18dda5a" || response.obj.quotations[i].materialId == "60f8435de6e54e96ba3595f576dd3ba3") {
this.quoteParameter[i]['isshow'] = true

sumdata = sumdata + response.obj.quotations[i].quantity * response.obj.quotations[i].weight
} else {
this.quoteParameter[i]['isshow'] = false
}
}
console.log('sumdata', sumdata);

if (sumdata > 1000) {
this.iszj = true
} else {
this.iszj = false
}

console.log(response)


if (response.code == 0) {
this.returnData = response.obj.quotations;
this.$vux.loading.hide()
let base64 = '';

function getBase64Image(img) {
let canvas = document.createElement("canvas");
canvas.width = img.width;
canvas.height = img.height;
let ctx = canvas.getContext("2d");
ctx.drawImage(img, 0, 0, img.width, img.height);
let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
let dataURL = canvas.toDataURL("image/" + ext);
return dataURL;
}
let image = new Image();
image.setAttribute("crossOrigin", 'Anonymous')
image.src = response.obj.quotations[response.obj.quotations.length - 1].image
image.onload = function () {
base64 = getBase64Image(image);

if (that.isUpFile == false) {
that.fileDataList = [];
}
that.isUpFile = true;

if (response.obj.quotations[response.obj.quotations.length - 1].materialId == "6c04a66b-a08b-11e8-8564-1c1b0daf" || response.obj.quotations[response.obj.quotations.length - 1].materialId == "806ef16d474445429d7ed8f7b18dda5a" || response.obj.quotations[response.obj.quotations.length - 1].materialId == "60f8435de6e54e96ba3595f576dd3ba3") {
response.obj.quotations[response.obj.quotations.length - 1]['isshow'] = true
} else {
response.obj.quotations[response.obj.quotations.length - 1]['isshow'] = false
}


that.fileDataList.push({

image: response.obj.quotations[response.obj.quotations.length - 1].image,
quotationName: response.obj.quotations[response.obj.quotations.length - 1].quotationName,
length: response.obj.quotations[response.obj.quotations.length - 1].length,
width: response.obj.quotations[response.obj.quotations.length - 1].width,
height: response.obj.quotations[response.obj.quotations.length - 1].height,
volume: response.obj.quotations[response.obj.quotations.length - 1].volume,
unit: response.obj.quotations[response.obj.quotations.length - 1].unit,
deliveryDays: response.obj.quotations[response.obj.quotations.length - 1].deliveryDays + '天',
materialName: '',
materialId: response.obj.quotations[response.obj.quotations.length - 1].materialId,
quantity: 1,
surface: '无',
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: "",
}],
qcIds: that.quoteParameter[that.quoteParameter.length - 1].qcIds,
colorName: response.obj.quotations[response.obj.quotations.length - 1].colorName,
colorId: response.obj.quotations[response.obj.quotations.length - 1].colorId,
price: response.obj.quotations[response.obj.quotations.length - 1].promotionTotal,
ossFileStl: response.obj.quotations[response.obj.quotations.length - 1].ossFileStl,
minimumPriceSign: response.obj.quotations[response.obj.quotations.length - 1].minimumPriceSign,
isshow: response.obj.quotations[response.obj.quotations.length - 1].isshow,

printingMethod: '请选择', //

weight: response.obj.quotations[response.obj.quotations.length - 1].weight,
deliveryDiscount: response.obj.quotations[response.obj.quotations.length - 1].deliveryDiscount,
manufactureId: response.obj.quotations[response.obj.quotations.length - 1].manufactureId,
manufactureName: response.obj.quotations[response.obj.quotations.length - 1].manufactureName,
qcId: response.obj.quotations[response.obj.quotations.length - 1].qcId,
listQc: response.obj.quotations[response.obj.quotations.length - 1].listQc,
offerType: response.obj.quotations[response.obj.quotations.length - 1].offerType,
ossDrc: response.obj.quotations[response.obj.quotations.length - 1].ossDrc,
listSurface: response.obj.quotations[response.obj.quotations.length - 1].listSurface,
filePath: response.obj.quotations[response.obj.quotations.length - 1].filePath,
fileName: response.obj.quotations[response.obj.quotations.length - 1].fileName,






gt: '无',
gxObjs: JSON.parse(JSON.stringify(that.gxObjs)),
nut: '',
attackTeeth: '',



























})
that.fileDataList[that.fileDataList.length - 1].materialName = that.materials
that.fileDataList[that.fileDataList.length - 1].surface = '无'
that.fileDataList[that.fileDataList.length - 1].surface = '无'


console.log('that.fileDataList', that.fileDataList);

if (type == '无图纸') {
document.querySelector('.previewBox').append(document.createElement('canvas'))
}

that.calculateTotalPrice();
that.noDrawingPopup = false;
}

} else {
that.$vux.toast.show({
type: 'warn',
text: response.msg
})
}
})
},


editParameter(mini) {

if (this.quoteParameter.length != 0) {
this.quoteParameter[this.fileIndex].minPriceType = ''
if (mini == '最低价') {
this.quoteParameter[this.fileIndex].minPriceType = '最低价'
}
}



console.log('editParameter', this.quoteParameter);


this.$request.post('/quotation/create', this.quoteParameter).then((response) => {
var sumdata = 0
for (var i = 0; i < response.obj.quotations.length; i++) {
this.quoteParameter[i].image = response.obj.quotations[i].image

if (response.obj.quotations[i].materialId == "6c04a66b-a08b-11e8-8564-1c1b0daf" || response.obj.quotations[i].materialId == "806ef16d474445429d7ed8f7b18dda5a" || response.obj.quotations[i].materialId == "60f8435de6e54e96ba3595f576dd3ba3") {
this.quoteParameter[i].isshow = true

sumdata = sumdata + response.obj.quotations[i].quantity * response.obj.quotations[i].weight
} else {
this.quoteParameter[i].isshow = false
}

}

if (sumdata > 1000) {
this.iszj = true
} else {
this.iszj = false
}


if (response.code == 0 && response.obj.quotations.length != 0) {

this.returnData = response.obj.quotations;

this.fileDataList[this.fileIndex].price = response.obj.quotations[this.fileIndex].promotionPrice;
this.fileDataList[this.fileIndex].minimumPriceSign = response.obj.quotations[this.fileIndex].minimumPriceSign;

if (mini == '最低价') {
for (let i = 0; i < this.materialsData.length; i++) {
if (response.obj.quotations[this.fileIndex].materialId == this.materialsData[i].id) {
this.fileDataList[this.fileIndex].materialName = this.materialsData[i].materialName;
}
}

this.fileDataList[this.fileIndex].materialId = response.obj.quotations[this.fileIndex].materialId;
this.fileDataList[this.fileIndex].colorName = response.obj.quotations[this.fileIndex].colorName;
this.fileDataList[this.fileIndex].surface = '无';
this.fileDataList[this.fileIndex].deliveryDays = response.obj.quotations[this.fileIndex].deliveryDays + '天';
















this.colorNumber = '', //潘通色号
this.colorNumberShow = false, //表面处理潘通色号


this.quoteParameter[this.fileIndex].materialName = response.obj.quotations[this.fileIndex].materialName;
this.quoteParameter[this.fileIndex].materialId = response.obj.quotations[this.fileIndex].materialId;
this.quoteParameter[this.fileIndex].colorName = response.obj.quotations[this.fileIndex].colorName;
this.quoteParameter[this.fileIndex].colorId = response.obj.quotations[this.fileIndex].colorId;
this.quoteParameter[this.fileIndex].listSurface = [{
surfaceName: '无',
id: 'default',
colorValue: '',
}];
this.quoteParameter[this.fileIndex].deliveryDays = response.obj.quotations[this.fileIndex].deliveryDays;
this.quoteParameter[this.fileIndex].unit = response.obj.quotations[this.fileIndex].unit;

}

if (mini == '应用全部') {
for (let i = 0; i < response.obj.quotations.length; i++) {
this.fileDataList[i].materialName = this.fileDataList[this.fileIndex].materialName;
this.fileDataList[i].colorName = response.obj.quotations[i].colorName;
this.fileDataList[i].surface = this.fileDataList[this.fileIndex].surface;
this.fileDataList[i].deliveryDays = response.obj.quotations[i].deliveryDays + '天';














this.fileDataList[i].unit = response.obj.quotations[i].unit;
this.fileDataList[i].quantity = response.obj.quotations[i].quantity;
this.fileDataList[i].price = response.obj.quotations[i].promotionTotal;
}

}


this.calculateTotalPrice();

}

})
},


calculateTotalPrice() {
this.totalPrice = 0;
for (let i = 0; i < this.fileDataList.length; i++) {
console.log();
this.totalPrice += Number(this.fileDataList[i].price * this.fileDataList[i].quantity);

}
this.totalPrice = this.totalPrice.toFixed(1);
},


applyAll(i) {

let index = i;

let materialsId = '';
for (let i = 0; i < this.materialsData.length; i++) {
if (this.materialsData[i].materialName == this.fileDataList[index].materialName) {
materialsId = this.materialsData[i].id;
}
}

let colorId = '';
for (let i = 0; i < this.colorData.length; i++) {
if (this.colorData[i].colorName == this.fileDataList[index].colorName) {
colorId = this.colorData[i].id;
}
}

let surfaceId = '';
for (let i = 0; i < this.surfaceData.length; i++) {
if (this.surfaceData[i].surfaceName == this.fileDataList[index].surface) {
surfaceId = this.surfaceData[i].id
}
}

for (let i = 0; i < this.fileDataList.length; i++) {
this.quoteParameter[i].materialId = materialsId
this.quoteParameter[i].colorId = colorId
this.quoteParameter[i].colorName = this.fileDataList[index].colorName
this.quoteParameter[i].listSurface[0].surfaceName = this.fileDataList[index].surface
this.quoteParameter[i].listSurface[0].id = surfaceId
this.quoteParameter[i].listSurface[0].colorValue = this.colorNumber
this.quoteParameter[i].deliveryDays = this.fileDataList[index].deliveryDays.split('天')[0]
this.quoteParameter[i].unit = this.fileDataList[index].unit
this.quoteParameter[i].quantity = this.fileDataList[index].quantity
}

this.editParameter('应用全部')

},

drcPreview(ossPath, file, parseObj, uploadTime) {








let that = this;

let base64 = '';

function getBase64Image(img) {
let canvas = document.createElement("canvas");
canvas.width = img.width;
canvas.height = img.height;
let ctx = canvas.getContext("2d");
ctx.drawImage(img, 0, 0, img.width, img.height);
let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
let dataURL = canvas.toDataURL("image/" + ext);
return dataURL;
}
let image = new Image();
image.setAttribute("crossOrigin", 'Anonymous')
image.src = parseObj.imageFile 
image.onload = function () {
base64 = getBase64Image(image);


that.quoteParameter.push({
length: Math.abs(Number(parseObj.x).toFixed(1)),
width: Math.abs(Number(parseObj.y).toFixed(1)),
height: Math.abs(Number(parseObj.z).toFixed(1)),
volume: Math.abs(Number(parseObj.actualVolume).toFixed(1)),
unit: 'mm',
deliveryDays: that.delivery,
materialId: that.materialsId,
quantity: 1,
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: '',
}],
colorId: that.colorId,
colorName: that.color,
ossFileStl: ossPath,
image: parseObj.imageFile,
firstUpload: '第一次上传',
minPriceType: '', //最低价
quotationName: file.name,
token: '',
ossDrc: parseObj.ossDrc,

qcId: parseObj.qcId,
qcIds: parseObj.qcIds,
listQc: parseObj.qcIds == '' ? null : parseObj.qcIds,
boolSv: true,
nut: '',
attackTeeth: '',



})

console.log('that.quoteParameter', that.quoteParameter);

setTimeout(() => {
that.getQuote()








})
}


let loadStart = Date.parse(new Date())


var camera, scene, renderer, controls;

var dracoLoader = new DRACOLoader();

console.log(dracoLoader);

dracoLoader.setDecoderPath('/static/draco/');

init();
animate();

function init() {
camera = new THREE.PerspectiveCamera(35, 375 / 375, 0.1, 1500);
camera.position.set(3, 0.25, 3);

scene = new THREE.Scene();
scene.background = new THREE.Color('#f5f5f5');



let light2 = new THREE.AmbientLight(0xFFFFFF, 0.5);

scene.add(light2);

let light3 = new THREE.PointLight(0xFFFFFF);
light3.position.set(1, -1, 1);
scene.add(light3);
let light4 = new THREE.PointLight(0xFFFFFF);
light4.position.set(-1, -1, 1);
scene.add(light4); {
let light4 = new THREE.PointLight(0xFFFFFF);
light4.position.set(1, -1, -1);
scene.add(light4);
}

dracoLoader.load(parseObj.fileName, function (geometry) { // that.$baseURL+'/'+
console.log(geometry);
geometry.computeVertexNormals();
geometry.computeBoundingBox();
let box = geometry.boundingBox;
var material1 = new THREE.MeshLambertMaterial({
ambient: '#555',
color: '#555',
specular: '#555',
shininess: -2000
});

var mesh = new THREE.Mesh(geometry, material1);

mesh.castShadow = true;
mesh.receiveShadow = true;
var maxSize = 0;
var size = box.getSize();
maxSize = Math.max(maxSize, size.x);
maxSize = Math.max(maxSize, size.y);
maxSize = Math.max(maxSize, size.z);
var scale = 2.0 / maxSize;
var center = new THREE.Vector3();
box.getCenter(center);
var matrix = new THREE.Matrix4();
matrix.scale(new THREE.Vector3(scale, scale, scale));
console.log('center', center, box, matrix);
mesh.position.set(-center.x, -center.y, -center.z);
mesh.updateMatrix();
mesh.applyMatrix(matrix);
window.mesh = mesh;
scene.add(mesh);

dracoLoader.dispose();
controls = new THREE.OrbitControls(camera, renderer.domElement);
controls.addEventListener("change", function () {
render();
});

render();
}, function (gress) {
console.log(gress);
}, function (erro) {
console.log(erro);
});

renderer = new THREE.WebGLRenderer({
antialias: true,
preserveDrawingBuffer: true,
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(375, 375);
renderer.gammaInput = true;
renderer.gammaOutput = true;



document.querySelector('.previewBox').append(renderer.domElement)
window.addEventListener('resize', onWindowResize, false);


}

function onWindowResize() {

camera.aspect = window.innerWidth / window.innerHeight;
camera.updateProjectionMatrix();
renderer.setSize(375, 375);
if (controls) controls.update();
}

function animate() {




requestAnimationFrame(animate);
}

function render() {

renderer.render(scene, camera);
}

},

closePreview() {
this.preview = false;
this.render = false;
},

threeParse(blob, myfile, ossPath) {
let that = this;

var userLanguage = window.navigator.userLanguage || window.navigator.language;

var container, camera, scene, renderer, controls, light, vol, mesh, height, heightFinal, width, widthFinal, depth,
depthFinal;

var density = parseFloat("1.05");
var filament_cost = parseFloat("200");
var filament_diameter = parseFloat("1.75");
var printing_speed = parseFloat("150");









function init(file) {




container = document.getElementById("abc");


camera = new THREE.PerspectiveCamera(37.8, 375 / 375, 1, 100000);

camera.position.z = 300;
camera.position.y = -500;
camera.position.x = -500;
camera.up = new THREE.Vector3(0, 0, 1);

scene = new THREE.Scene();

scene.background = new THREE.Color('#f5f5f5');

let extension = myfile.name.split(".").pop().toLowerCase();

let reader = new FileReader();



if (extension == "stl") {
reader.readAsArrayBuffer(blobfile);
} else if (extension == "3ds") {
reader.readAsArrayBuffer(blobfile);
} else if (extension == "obj") {
reader.readAsText(blobfile);
} else if (extension == "json") {
reader.readAsText(blobfile);
} else {

if (userLanguage.substring(0, 2) == "es") {
alert("不支持的文件");
} else {
alert("不支持的文件");
}
}
reader.addEventListener("load", function (event) {

console.log(event);

var contents = event.target.result;
console.log(contents);
var geometry;
if (extension == "obj") {
var object = new THREE.OBJLoader().parse(contents);
var sceneConverter = new THREE.Scene();
sceneConverter.add(object);
var exporter = new THREE.STLExporter();
contents = exporter.parse(sceneConverter);

if (object.children.length > 1) {
that.$vux.confirm.show({
title: myfile.name + '模型是组装模型，将会拆分打印',
})
}


} else if (extension == "3ds") {
var object = new THREE.TDSLoader().parse(contents);
var sceneConverter = new THREE.Scene();
sceneConverter.add(object);
var exporter = new THREE.STLExporter();
contents = exporter.parse(sceneConverter);


}











var geometry = new THREE.STLLoader().parse(contents);

geometry.computeFaceNormals();
geometry.computeVertexNormals();
geometry.center();

var material = new THREE.MeshPhongMaterial({
color: '#ccc', //48dc39
side: THREE.DoubleSide
});
mesh = new THREE.Mesh(geometry, material);


vol = 0;

mesh.traverse(function (child) {

if (child instanceof THREE.Mesh) {
var positions = child.geometry.getAttribute("position").array;

for (var i = 0; i < positions.length; i += 9) {
var t1 = {};
t1.x = positions[i + 0];
t1.y = positions[i + 1];
t1.z = positions[i + 2];

var t2 = {};
t2.x = positions[i + 3];
t2.y = positions[i + 4];
t2.z = positions[i + 5];

var t3 = {};
t3.x = positions[i + 6];
t3.y = positions[i + 7];
t3.z = positions[i + 8];

vol += signedVolumeOfTriangle(t1, t2, t3);
}
}
});

var box = new THREE.Box3().setFromObject(mesh);

height = box.max.z - box.min.z;
width = box.max.x - box.min.x;
depth = box.max.y - box.min.y;

heightFinal = height / 10;
heightFinal = heightFinal;
widthFinal = width / 10;
widthFinal = widthFinal;
depthFinal = depth / 10;
depthFinal = depthFinal;
var volumeFinal = vol / 1000;
volumeFinal = volumeFinal;
var weightFinal = volumeFinal * density;
weightFinal = weightFinal;

var filament_length = parseFloat((vol / (filament_diameter / 2) ^ 2 / Math.PI) * 2 / 10);
filament_length = parseFloat(filament_length).toFixed(0);

var hours = Math.floor((filament_length / printing_speed) / 60);
hours = parseFloat(hours).toFixed(0);

var minutes = (filament_length / printing_speed) % 60;
minutes = parseFloat(minutes).toFixed(0);

if (minutes == 0) {
minutes = 1;
}

var finalCost = weightFinal * filament_cost / 1000;
finalCost = parseFloat(finalCost);

console.log(volumeFinal * 1000)
console.log(widthFinal * 10)
console.log(depthFinal * 10)
console.log(heightFinal * 10)

var distance;

if (height > width && height > depth) {
distance = height * 2;
} else if (width > height && width > depth) {
distance = width * 2;
} else if (depth > height && depth > width) {
distance = depth * 2;
} else {
distance = depth * 4;
}

camera.position.set(0, -distance, 0);

var x = distance + 200;
var y = distance + 200;
var division_x = Math.floor(x / 10);
var division_y = Math.floor(y / 10);

var wirePlane = new THREE.Mesh(new THREE.PlaneGeometry(x, y, division_x, division_y), new THREE
.MeshPhongMaterial({


emissive: 'green',
color: 'green',
wireframe: true,
wireframeLinewidth: 1
}));
wirePlane.receiveShadow = true;
wirePlane.position.z = box.min.z - 0.1;





controls = new THREE.OrbitControls(camera, renderer.domElement);
controls.update();

scene.add(mesh);


controls.addEventListener("change", function () {
let pos = new THREE.Vector3();
camera.getWorldPosition(pos)
light.position.copy(pos);
renderer.render(scene, camera);
});
let pos = new THREE.Vector3();
camera.getWorldPosition(pos)
light.position.copy(pos);
renderer.render(scene, camera);


setTimeout(() => {
var canvasUrl = renderer.domElement.toDataURL("image/png");
that.quoteParameter.push({
length: Math.abs((depthFinal * 10).toFixed(1)),
width: Math.abs((widthFinal * 10).toFixed(1)),
height: Math.abs((heightFinal * 10).toFixed(1)),
volume: Math.abs((volumeFinal * 1000).toFixed(1)),
unit: 'mm',
deliveryDays: that.delivery,
materialId: that.materialsId,
quantity: 1,
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: '',
}],
colorId: that.colorId,
colorName: that.color,
ossFileStl: ossPath,
image: canvasUrl,
firstUpload: '第一次上传',
minPriceType: '', //最低价
quotationName: myfile.name,
token: '',

})
that.getQuote()
})
}, false);

light = new THREE.HemisphereLight(0xE8E8E8, 0x000000, 1);
light.position.set(0, 0, 0);
scene.add(light);

renderer = new THREE.WebGLRenderer({
antialias: true,
preserveDrawingBuffer: true,
});
renderer.setSize(375, 375);

$(renderer.domElement).css({
'position': 'absolute',
'display': 'none',



})
document.querySelector('.previewBox').append(renderer.domElement)



window.addEventListener("resize", onWindowResize, false);
}
this.render = true;











setTimeout(() => {
this.render = false;
}, 5000)

function onWindowResize() {

camera.updateProjectionMatrix();

renderer.setSize(375, 375);

renderer.render(scene, camera);
}

var blobfile = new Blob([blob], {
type: 'application/json'
});

console.log(blobfile);



init(blobfile);

















window.onload = function () {
document.getElementById("modelOBJ").disabled = false;
document.getElementById("modelOBJ").value = null;
}
},


fileScanner(filePath, file) {



var WIDTH, HEIGHT;
var renderer;

function initThree() {

WIDTH = 375;
HEIGHT = 375;
/* 渲染器 */
renderer = new THREE.WebGLRenderer({
antialias: true, //是否开启反锯齿
precision: "highp", //着色精度选择
alpha: true, //是否可以设置背景色透明
premultipliedAlpha: false,
stencil: false,
preserveDrawingBuffer: true, //是否保存绘图缓冲
maxLights: 3 
});
renderer.setSize(WIDTH, HEIGHT);

renderer.setClearColor(new THREE.Color('#f5f5f5'));
renderer.gammaInput = true;
renderer.gammaOutput = true;











}

/* 设置摄像头 */
var camera;

function initCamera() {
var VIEW_ANGLE = 45,
ASPECT = WIDTH / HEIGHT,
NEAR = 1,
FAR = 10000;

camera = new THREE.PerspectiveCamera(VIEW_ANGLE, ASPECT, NEAR, FAR);

camera.position.set(50, 0, 0);
camera.up.set(0, 0, 1)

camera.lookAt(300, 0, 0);






}

/* 场景 */
var scene;

function initScene() {
scene = new THREE.Scene();


}

/* 灯光 */
var light, light2, light3;

function initLight() {

light = new THREE.DirectionalLight(0xFFFFFF); 
light.position.set(0, 99, 0).normalize();
scene.add(light);


light2 = new THREE.AmbientLight(0x999999); 

scene.add(light2);

light3 = new THREE.PointLight(0xffffff); 
light3.position.set(250, -200, 100);
scene.add(light3);






}

/* 显示对象 */
var cube;

var initObject = () => {



var stlloader = new STLLoader();





var geometry = new THREE.Geometry(260, 35, 185, 1, 1, 1)




stlloader.load(filePath, (geometry) => {
















var material1 = new THREE.MeshLambertMaterial({
ambient: '#555',
color: '#555',
specular: '#555',
shininess: -2000
});


var mat = new THREE.MeshLambertMaterial({
color: 0xFFD700
});
var mesh = new THREE.Mesh(geometry, material1)
console.log(geometry);


geometry.center();

mesh.rotation.set(0, 0, 1.55);

mesh.position.set(0, 0, 0);

var originalx = geometry.boundingBox.max.x;
var originaly = geometry.boundingBox.max.y;
var originalz = geometry.boundingBox.max.z;
console.log(originalx, originaly, originalz);


var originalmax = Math.max(originalx, originaly, originalz);






if (geometry instanceof THREE.BufferGeometry) {
geometry = new THREE.Geometry().fromBufferGeometry(geometry);


}



var volume = 0;
var volumes = 0;
var Area = 0;

for (let f = 0, fl = geometry.faces.length; f < fl; f++) {
var face = geometry.faces[f];
var vA = geometry.vertices[face.a];
var vB = geometry.vertices[face.b];
var vC = geometry.vertices[face.c];

var x1 = vA.x,
x2 = vB.x,
x3 = vC.x;
var y1 = vA.y,
y2 = vB.y,
y3 = vC.y;
var z1 = vA.z,
z2 = vB.z,
z3 = vC.z;

var V = (-x3 * y2 * z1 + x2 * y3 * z1 + x3 * y1 * z2 - x1 * y3 * z2 - x2 * y1 * z3 + x1 * y2 * z3) / 6;
volume += V;

}


function volumeOfT(p1, p2, p3) {
var v321 = p3.x * p2.y * p1.z;
var v231 = p2.x * p3.y * p1.z;
var v312 = p3.x * p1.y * p2.z;
var v132 = p1.x * p3.y * p2.z;
var v213 = p2.x * p1.y * p3.z;
var v123 = p1.x * p2.y * p3.z;
return (-v321 + v231 + v312 - v132 - v213 + v123) / 6.0;
}

function AreaOfTriangle(p1, p2, p3) {
var ax = p2.x - p1.x;
var ay = p2.y - p1.y;
var az = p2.z - p1.z;
var bx = p3.x - p1.x;
var by = p3.y - p1.y;
var bz = p3.z - p1.z;
var cx = ay * bz - az * by;
var cy = az * bx - ax * bz;
var cz = ax * by - ay * bx;
return (0.5 * Math.sqrt(cx * cx + cy * cy + cz * cz));
}

for (var i = 0; i < geometry.faces.length; i++) {
var Pi = geometry.faces[i].a;
var Qi = geometry.faces[i].b;
var Ri = geometry.faces[i].c;
var P = new THREE.Vector3(geometry.vertices[Pi].x, geometry.vertices[Pi].y, geometry.vertices[Pi].z);
var Q = new THREE.Vector3(geometry.vertices[Qi].x, geometry.vertices[Qi].y, geometry.vertices[Qi].z);
var R = new THREE.Vector3(geometry.vertices[Ri].x, geometry.vertices[Ri].y, geometry.vertices[Ri].z);
volumes += volumeOfT(P, Q, R); 

Area += AreaOfTriangle(R, Q, P);
}









let length = Math.ceil(geometry.boundingBox.max.x + Math.abs(geometry.boundingBox.min.x))
let width = Math.ceil(geometry.boundingBox.max.y + Math.abs(geometry.boundingBox.min.y))
let height = Math.ceil(geometry.boundingBox.max.z + Math.abs(geometry.boundingBox.min.z))



document.querySelector('.previewBox').append(renderer.domElement)


var arg = 15 / originalmax;


mesh.scale.set(arg, arg, arg);

scene.add(mesh)





var canvasUrl = renderer.domElement.toDataURL("image/png");

this.quoteParameter.push({
length: Math.abs(length),
width: Math.abs(width),
height: Math.abs(height),
volume: Math.abs(volume.toFixed(1)),
unit: 'mm',
deliveryDays: this.delivery,
materialId: this.materialsId,
quantity: 1,
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: '',
}],
colorId: this.colorId,
colorName: this.color,
ossFileStl: filePath,
image: canvasUrl,
firstUpload: '第一次上传',
minPriceType: '', //最低价
quotationName: file.name,
token: '',
})
setTimeout(() => {
this.getQuote()
})






},

function (xhr) {
if ((xhr.loaded / xhr.total * 100) + '% loaded' === '100% loaded') {

}
},

)
}


var effect;
var controls;

var _this = this;

function initControl() {
effect = new AsciiEffect(renderer);
effect.setSize(WIDTH, HEIGHT);
controls = new TrackballControls(camera, renderer.domElement);

controls.minDistance = 30;

controls.maxDistance = 150;

_this.controls = controls
}


function animate() {
requestAnimationFrame(animate);
controls.update();
effect.render(scene, camera);
}


function threeStart() {

initThree();
initScene();

initCamera();
initLight();

initObject();
initControl();
animate();
}

threeStart();
},


defaultList() {

this.fileDataList = [{

image: require('../../assets/images/printLogo.png'),
quotationName: 'stl',
length: '0',
width: '0',
height: '0',
volume: '0',
unit: 'mm',
deliveryDays: '',
materialName: '',
materialId: '',
quantity: 1,
surface: '无',
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: "",
}],
colorName: '',
colorId: '',
price: '0',
ossFileStl: '',
qcIds: '',
offerType: '',
printingMethod: '请选择',
gxObjs: JSON.parse(JSON.stringify(this.gxObjs)),
gt: '无',
nut: '',
attackTeeth: '',



}]

},


cutNoDrawing(type) {
if (type == 'knowVolume') {
this.noDrawingType = 'knowVolume'
} else if (type == 'knowWeight') {
this.noDrawingType = 'knowWeight'
}

this.noDrawingName = '';
this.noDrawingWeight = '';
this.noDrawingVolume = '';
this.noDrawingLength = 0;
this.noDrawingWidth = 0;
this.noDrawingHeight = 0;


},

noDrawingPrice() {
if (this.noDrawingType == 'knowVolume' && (this.noDrawingName == '' || this.noDrawingVolume == '')) {
this.hint = true;
this.hintText = '请输入参数'
return false;
}

if (this.noDrawingType == 'knowWeight' && (this.noDrawingName == '' || this.noDrawingWeight == '')) {
this.hint = true;
this.hintText = '请输入参数'
return false;
}
this.noDrawingMaterialsSelect = false;
this.materialsPopup = false;
this.quoteParameter.push({
length: this.noDrawingLength,
width: this.noDrawingWidth,
height: this.noDrawingHeight,
volume: this.noDrawingVolume,
unit: 'mm',
deliveryDays: this.delivery,
materialId: this.materialsId,
quantity: 1,
listSurface: [{
surfaceName: '无',
id: 'default',
colorValue: "",
}],
colorId: this.colorId,
colorName: this.color,
ossFileStl: '',
image: this.noDrawingImg,
firstUpload: '第一次上传',
minPriceType: '', //最低价
quotationName: this.noDrawingName,
token: '',
offerType: '无图纸报价',
nut: '',
attackTeeth: '',

})

if (this.noDrawingType == 'knowWeight') {
this.$request.post('/quotation/getVolumeByWeight', {
materialId: this.noDrawingMaterialsId,
weight: this.noDrawingWeight,
}).then((response) => {
console.log(response);
if (response.code == 0) {
this.noDrawingVolume = response.obj;
this.quoteParameter[this.quoteParameter.length - 1].volume = response.obj;
this.getQuote('无图纸报价')
}
})
}

if (this.noDrawingType == 'knowVolume') {
this.getQuote('无图纸报价')
}
},


getNoDrawingVolume() {
this.$request.post('/quotation/getVolumeByWeight', {
materialId: this.noDrawingMaterialsId,
weight: this.noDrawingWeight,
}).then((response) => {
console.log(response);
if (response.code == 0) {
this.noDrawingVolume = response.obj;
}
})
},


async cartAndBuy(url, type) {


this.cartOrBuy = type;


if (this.fileDataList.length == 0 || (this.fileDataList.length == 1 && this.fileDataList[0].quotationName == 'stl')) {
this.$vux.toast.show({
type: 'warn',
text: '请上传文件'
})
return false;
}



if (common.getCookie('_token') == null) {
this.loginShow = true;
return false;
}



for (let i = 0; i < this.fileDataList.length; i++) {
if (this.fileDataList[i].qcIds) {
if (this.fileDataList[i].printingMethod == '' || this.fileDataList[i].printingMethod == '请选择') {
this.$vux.toast.show({
type: 'warn',
text: '检测到您的图纸包含装配件或分件，请选择打印方式！'
})
return false;
}

}
}


let cartData = [];

for (let i = 0; i < this.fileDataList.length; i++) {


let isSurfaceCode = this.fileDataList[i].listSurface[0].surfaceCode;
if (!isSurfaceCode && this.fileDataList[i].listSurface[0].surfaceName.indexOf("无") == -1) {
let materialId = this.fileDataList[i].materialId;
let res1 = await this.getMaterialRelated(materialId);
let slist = res1.obj.sList;
slist.unshift({
id: "default",
surfaceName: "无"
});
let surfaceOptions = slist;

for (let lp = 0; lp < surfaceOptions.length; lp++) {
let surfaceName = this.fileDataList[i].listSurface[0].surfaceName;
if (surfaceName.indexOf(surfaceOptions[lp].surfaceName) != -1) {
this.fileDataList[i].listSurface[0].surfaceCode = surfaceOptions[lp].surfaceCode;
break;
}
}
}


cartData.push({
token: common.getCookie('_token'),
length: this.fileDataList[i].length,
width: this.fileDataList[i].width,
height: this.fileDataList[i].height,
volume: this.fileDataList[i].volume,
weight: this.fileDataList[i].weight,
deliveryDays: this.fileDataList[i].deliveryDays.split('天')[0],
deliveryDiscount: this.fileDataList[i].deliveryDiscount,
unit: this.fileDataList[i].unit,
manufactureId: this.fileDataList[i].manufactureId,
manufactureName: '',
materialId: this.fileDataList[i].materialId,
materialName: this.fileDataList[i].materialName,
quantity: this.fileDataList[i].quantity,
fileName: this.fileDataList[i].quotationName,
filePath: this.fileDataList[i].ossFileStl,
ossFileStl: this.fileDataList[i].ossFileStl,
image: this.fileDataList[i].image,
listSurface: this.fileDataList[i].listSurface,
ossDrc: this.fileDataList[i].ossDrc,
printingMethod: this.fileDataList[i].printingMethod == '请选择' ? '' : this.fileDataList[i].printingMethod, //打印方式
offerType: this.fileDataList[i].offerType,
colorId: this.fileDataList[i].colorId,
colorName: this.fileDataList[i].colorName,
listQc: this.fileDataList[i].listQc,
qcId: this.fileDataList[i].qcId,

nut: this.fileDataList[i].nut,
attackTeeth: this.fileDataList[i].attackTeeth,


})
}


console.log('cartData', cartData);

this.$request.post(url, cartData).then((response) => {
console.log(response);

if (response.code == 0) {
if (this.cartOrBuy == 'cart') {
this.$router.push({
path: 'shoppingCart',
query: {
type: 'print'
}
})
}
if (this.cartOrBuy == 'buy') {
this.$router.push({
path: 'submitOrder',
query: {
cartType: 'cartdirect',
type: 'print'
}
})
}
} else {
this.$vux.toast.show({
type: 'cancel',
text: response.msg
})
}
})
},


loginCallback(status, response) {

if (response.code == 0) {
this.loginShow = false
this.$vux.toast.show({
type: 'success',
text: '登录成功'
})
setTimeout(() => {
if (this.cartOrBuy == 'cart') {
this.cartAndBuy('/quotation/toCart', this.cartOrBuy);
} else if (this.cartOrBuy == 'buy') {
this.cartAndBuy('/quotation/toBuy', this.cartOrBuy);
}
}, 1000)
}
},


comparison(i) {







if (this.fileDataList.length == 1 && this.fileDataList[0].quotationName == 'stl') {
this.$vux.toast.show({
type: 'warn',
text: '请上传文件'
})
return false;
}

this.$router.push({
name: 'contrastMaterial',
query: {
imgurl: this.fileDataList[i].image,
length: this.fileDataList[i].length,
width: this.fileDataList[i].width,
height: this.fileDataList[i].height,
unit: this.fileDataList[i].unit,
volume: this.fileDataList[i].volume,
deliveryDiscount: this.returnData[i].deliveryDiscount,
deliveryDays: this.returnData[i].deliveryDays,
colorName: encodeURI(this.fileDataList[i].colorName),
colorId: this.fileDataList[i].colorId
}
})

},


editImg() {
this.fileDataList[this.fileIndex].image = document.querySelectorAll('.previewBox canvas')[this.fileIndex].toDataURL("image/png");
this.preview = false;
},









},

deactivated() {

console.log('1232132')
return false;
},

created() {
console.log(document.documentElement.clientHeight);

this.getMaterials();
this.defaultList(); 
this.getPromotion() 
this.getSurfaceDay() 

if (this.$route.params.title != '' && this.$route.params.title != undefined && this.$route.params.title != null) {
this.noticePopup = true;
}


if (common.getCookie('_isMonthlyKnots') == 'Y') {
this.isMonthly = false;
}





},

}



// WEBPACK FOOTER //
// ./src/views/print/script.js